import React from "react";
import SearchInput from "../../../widget/common/form/SearchInput";
import ForwardChatButtons from "./widget/ForwardChatButtons";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { ForwardChatContextImport } from "../../../provider/chats/chats/forward_chat/ForwardChatContextProvider";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import ForwardChatList from "./widget/ForwardChatList";

const ForwardChatContent = (props: { isMedia: boolean }) => {
  const type: number = ResponsiveDeviceType();

  const { handleOnChange, clearSearch, searchValue, showSearch, profileList } =
    ForwardChatContextImport();

  return (
    <div className="h-100">
      {showSearch && profileList != null && (
        <SearchInput
          name="search-chat-forward"
          placeHolder="search"
          handleOnChange={handleOnChange}
          onClickSuffix={clearSearch}
          suffixIcon={
            type === 3
              ? UtilityHelper.isNotEmpty(searchValue)
                ? "close"
                : ""
              : "close"
          }
          value={searchValue}
          autoFocus={false}
          listLogic={true}
        />
      )}

      <ForwardChatList />

      {type === 3 && <ForwardChatButtons isMedia={props.isMedia} />}
    </div>
  );
};

export default ForwardChatContent;
